 export const roundValue = (value?: number): string => {
  if (value === undefined) return "0.00";
  const num = Number(value);
  const thirdDecimal = Math.floor(num * 1000) % 10;
  return thirdDecimal >= 5 ? (Math.ceil(num * 100) / 100).toFixed(2) : num.toFixed(2);
};

